import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; {new Date().getFullYear()} Emanuele Nevali. All rights reserved.</p>
            <div>
                <a href="https://github.com/emanuelenevali" target="_blank" rel="noopener noreferrer">GitHub</a>
                <a href="https://www.linkedin.com/in/emanuele-nevali-090820245/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                {/* <a href="https://twitter.com/yourusername" target="_blank" rel="noopener noreferrer">Twitter</a> */}
            </div>
        </footer>
    );
};

export default Footer;